import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface AdminPageHeaderProps {
    title: string;
    icon?: LucideIcon;
    actions?: ReactNode;
    subtitle?: string;
}

const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({ title, icon: Icon, actions, subtitle }) => {
    return (
        <div className="border-b border-slate-200 bg-white px-8 h-[72px] shrink-0 flex items-center justify-between">
            <div className="flex items-center gap-4">
                {Icon && (
                    <div className="p-2 bg-indigo-50 text-indigo-600 rounded-xl">
                        <Icon size={24} />
                    </div>
                )}
                <div>
                    <h1 className="text-xl font-black text-slate-800">{title}</h1>
                    {subtitle && <p className="text-xs text-slate-400 font-medium mt-0.5">{subtitle}</p>}
                </div>
            </div>
            {actions && <div className="flex items-center gap-3">{actions}</div>}
        </div>
    );
};

export default AdminPageHeader;
